import { createStandardAction } from 'typesafe-actions';

export const updateDownloadItems = createStandardAction(
  'DOWNLOAD_UPDATE_ITEMS'
)<any>();
export const resetDownloadItems = createStandardAction('DOWNLOAD_RESET_ITEMS')<
  void
>();
